export default function ccFetch(url, options) {
  if (options == null) options = {}
  if (options.credentials == null) options.credentials = 'include' //'same-origin'
  let token = localStorage.getItem("atk")
  if (token) {
    if (options.headers == null) options.headers = {}
    options.headers.authorization = `Bearer ${token}`
    options.headers.mode = 'cors'
    // options.headers['Access-Control-Allow-Origin'] = '*'
  }

  return fetch(url, options)
    .then(function(response) {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then(errorObject => {
            return Promise.reject({
              status: response.status,
              ok: false,
              statusText: response.statusText,
              err: errorObject
            });
          });
        } else {
          return response.text().then(errorMsg => {
            return Promise.reject({
              status: response.status,
              ok: false,
              statusText: response.statusText,
              err: errorMsg
            });
          });
        }
      };
    
        
        // let error = new Error(response.json() || response.statusText || response.status)
        // error.response = response
        // return Promise.reject(response.json())
        // return response.json().then(r => )
      // }
    })
}
